export default __webpack_public_path__ + "960c74401ba8c4ae46af9c6d483e4ff8.png";